import { datadogRum } from '@datadog/browser-rum'
import debug from 'debug'
import { getDomain } from '../../parameters'

const d = debug('rum')

let initialized = false

const getEnv = () => {
  switch (getDomain()) {
    case 'mappy':
      return 'prod'
    case 'mappyrecette':
      return 'recette'
    case 'mappysnap':
    default:
      return 'snap'
  }
}

const regexMappyDomain = /.*mappy(snap|recette|qt|)\.com\/.*/

export const beforeSend = (event, context) => {
  const url = event?.error?.resource?.url ?? event?.resource?.url

  if (!url) return true
  const isErrorFromMappy = regexMappyDomain.test(url)
  if (d.enabled) d(`beforeSend: ${isErrorFromMappy ? 'accepted' : 'REFUSED'}: ${url}`, event, context)
  return isErrorFromMappy
}

export const initDatadogRum = cookieConsent => {
  if (cookieConsent) {
    const applicationId = global?.__DATADOG_RUM_APP_ID__
    const clientToken = global?.__DATADOG_RUM_CLIENT_TOKEN__
    const sessionSampleRate = global?.__DATADOG_RUM_SESSION_SAMPLE_RATE__ ?? 0.001
    const sessionReplaySampleRate = global?.__DATADOG_RUM_SESSION_REPLAY_SAMPLE_RATE__ ?? 0

    const datadogConf = {
      applicationId,
      clientToken,
      site: 'datadoghq.eu',
      service: 'mappy-web',
      env: getEnv(),
      version: global.__APP_VERSION__,
      sessionSampleRate,
      sessionReplaySampleRate,
      defaultPrivacyLevel: 'mask-user-input',
      beforeSend
    }

    if (!initialized) {
      if (d.enabled) d('Starting Datadog RUM', datadogConf)
      datadogRum.init(datadogConf)
      initialized = true
    }

    if (d.enabled) d('update consent for Datadog RUM', datadogConf)
    datadogRum.setTrackingConsent('granted')
  } else {
    if (d.enabled) d('Disable Datadog RUM')
    datadogRum.setTrackingConsent('not-granted')
  }
}

export const addDatadogRumError = (err, context) => datadogRum.addError(err, context)
